export default __webpack_public_path__ + "0792e34464378ef267ffa1ecb2b790ac.jpg";